import { SocialShareLinkBuilder } from "../../services";

export const shareContentLinks = (sharingLink: string, subject?: string) => [
  SocialShareLinkBuilder.build({ type: 'facebook', sharingLink }),
  SocialShareLinkBuilder.build({ type: 'twitter', sharingLink }),
  SocialShareLinkBuilder.build({ type: 'email', sharingLink, subject }),
]
